/**
 * Datepicker Init
 * Автоматическая инициализация Flatpickr на всех input[type="date"].
 * Работает для существующих и динамически добавленных элементов.
 */
(function () {
    'use strict';

    if (typeof flatpickr === 'undefined') {
        return;
    }

    const DEFAULT_OPTIONS = {
        dateFormat: 'Y-m-d',
        allowInput: true,
        disableMobile: true,
        locale: {
            firstDayOfWeek: 1
        }
    };

    function initDatepicker(input) {
        if (!input || input._flatpickr || input.dataset.flatpickrInit === '1') {
            return;
        }
        input.dataset.flatpickrInit = '1';
        flatpickr(input, DEFAULT_OPTIONS);
    }

    function initAll(root) {
        const scope = root && root.querySelectorAll ? root : document;
        const inputs = scope.querySelectorAll('input[type="date"]');
        for (let i = 0; i < inputs.length; i++) {
            initDatepicker(inputs[i]);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
        initAll(document);
    }

    // Следим за динамически добавляемыми инпутами
    if (typeof MutationObserver !== 'undefined') {
        const observer = new MutationObserver(function (mutations) {
            for (let i = 0; i < mutations.length; i++) {
                const added = mutations[i].addedNodes;
                for (let j = 0; j < added.length; j++) {
                    const node = added[j];
                    if (node.nodeType !== 1) continue;
                    if (node.matches && node.matches('input[type="date"]')) {
                        initDatepicker(node);
                    } else if (node.querySelectorAll) {
                        initAll(node);
                    }
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Экспорт для ручной инициализации при необходимости
    window.initDatepickers = initAll;
})();
